import smartSolveApi from './instances/smartsolve';

export const getAISummary = async (params = {}) => {
  try {
    const response = await smartSolveApi.post('/summarization', params);

    return response.data;
  } catch (e) {
    throw new Error(`getAISummaryApiResults() failed: ${e}`);
  }
};
